import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewEmployeePulsePageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.EMPLOYEE_PULSE,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewEmployeePulseDashboardPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.EMPLOYEE_PULSE_DASHBOARD,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
